import { DomainSessionId, ProductType, UserId } from '@hc-frontend/core-types';
import { z } from 'zod';

export const LeadProductOptions = z.object({
  domainSessionId: DomainSessionId,
  userId: UserId,
  currentProductType: ProductType,
  newProductType: ProductType,
});

export type LeadProductOptions = z.infer<typeof LeadProductOptions>;
